import { render, staticRenderFns } from "./WizardHelp.vue?vue&type=template&id=dcf12722&lang=pug"
import script from "./WizardHelp.vue?vue&type=script&lang=js"
export * from "./WizardHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SurveyHideNextCompleteStyle: require('/home/docker/code/frontend/components/survey/HideNextCompleteStyle.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
